export default class ChangePasswordModel {
    constructor(
        public currentPassword: string = "",
        public newPassword: string = "",
        public newPasswordConfirm: string = "",
    ) { }
}